module.exports = __webpack_public_path__ + "img/28-soldier.f0b9705a.svg";